var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 9.25564L9.18761 17.1873C9.20708 17.4838 9.45322 17.7143 9.75031 17.7143H14.2497C14.5468 17.7143 14.7929 17.4838 14.8124 17.1873L15.3333 9.25564M8.66667 9.25564H7M8.66667 9.25564H9.77778M15.3333 9.25564H17M15.3333 9.25564H14.2222M9.77778 9.25564V8.12782C9.77778 7.50494 10.2827 7 10.9056 7H13.0944C13.7173 7 14.2222 7.50494 14.2222 8.12782V9.25564M9.77778 9.25564H14.2222",
    stroke: "#878787",
    strokeWidth: 1.12782
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteB);
export default __webpack_public_path__ + "static/media/deleteB.af0eca196f7696caacfe8f669c1d8079.svg";
export { ForwardRef as ReactComponent };